"use strict";

var _toConsumableArray = require("/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markdownPlugins = exports.markdownPluginsForTransfromMarkdown = void 0;
var remark_sub_super_1 = __importDefault(require("remark-sub-super"));
var remark_underline_1 = __importDefault(require("remark-underline"));
var react_color_text_1 = __importDefault(require("./plugins/react-color-text"));
var underlineOptions = {
  marker: '++'
};
exports.markdownPluginsForTransfromMarkdown = [remark_sub_super_1.default, [remark_underline_1.default, underlineOptions]];
exports.markdownPlugins = [].concat(_toConsumableArray(exports.markdownPluginsForTransfromMarkdown), [[react_color_text_1.default, {
  lowercase: false
}]]);